import { render, staticRenderFns } from "./AddUserGroupTransfer.vue?vue&type=template&id=4a1f01c5"
import script from "./AddUserGroupTransfer.vue?vue&type=script&lang=js"
export * from "./AddUserGroupTransfer.vue?vue&type=script&lang=js"
import style0 from "./AddUserGroupTransfer.vue?vue&type=style&index=0&id=4a1f01c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports